const hasSortForScope = (sortByFields, scope) =>
  Array.isArray(sortByFields) &&
  sortByFields.some(
    entry =>
      entry?.scope === scope && entry?.fieldId && (entry.direction === 'asc' || entry.direction === 'desc')
  );

const applyLegacySpeakerSort = speakers =>
  [...(speakers || [])].sort((left, right) =>
    (left.last_name || '').localeCompare(right.last_name || '')
  );

export const orderSpeakersForEmbed = (speakers, sortByFields, scope) => {
  if (hasSortForScope(sortByFields, scope)) {
    return speakers || [];
  }

  return applyLegacySpeakerSort(speakers);
};

export { hasSortForScope };
